import { render, staticRenderFns } from "./NewProjectRevenueTemplates.vue?vue&type=template&id=062dd873&"
import script from "./NewProjectRevenueTemplates.vue?vue&type=script&lang=js&"
export * from "./NewProjectRevenueTemplates.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectRevenueTemplates.vue?vue&type=style&index=0&id=062dd873&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports